import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/Users/joseph/projects/moneyline/client/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/article/article-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/news/article.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/joseph/projects/moneyline/client/src/components/news/recent-news.tsx");
;
import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/components/primitives/button.tsx");
